// Rebuy/addon capability is an allow-list: any unknown/new tournamentType
// (e.g. "shootout") must behave like freezeout, so never test != "freezeout".
// Mirrors isRebuyCapable in functions/bvapi.js.
export function isRebuyCapable(type: string | undefined | null): boolean {
  return type === "rebuy_tournament" || type === "reentry_tournament";
}
